// eslint-disable-next-line import/prefer-default-export
export const StepsControl = {
  WelcomePage: 0,
  GeneralInformation: 1,
  CompanyInformation: 2,
  TermsInformation: 3,
};

export const IS_SUB_ACCOUNT_URL = '/register-sub-account';
